
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetohublicabservice() {



    const cardData =
    {
        keyword: 'Pune to Hubli Cab Service ',
        heading: 'Platinum24 Cabs: Pune to Hubli Cab Service',
        headingDescription: ' Platinum24 Cabs offers reliable Pune to Hubli cab service, perfect for business professionals, families, and tourists traveling across Maharashtra and Karnataka. Whether you’re heading to Hubli for corporate work, visiting family, or exploring local attractions like Unkal Lake and Nrupatunga Hill, our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a comfortable and safe journey. With experienced chauffeurs, punctual pickups, and transparent pricing, we make long-distance travel convenient and stress-free. From one-way drops to round-trip packages, Platinum24 Cabs guarantees dependable service and a smooth Pune to Hubli travel experience.',

        top: 'Top Places to Visit in Hubli with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Unkal Lake",
    "description": "Unkal Lake is one of Hubli’s most popular leisure spots, spread over 200 acres. It features a statue of Swami Vivekananda in the middle of the lake. Boating, jogging tracks, and gardens make it ideal for family outings. Sunsets here are particularly stunning. The lake also supports birdwatching with migratory species. Unkal Lake is Hubli’s scenic recreational retreat."
  },
  {
    "title": "Chandramouleshwara Temple",
    "description": "The Chandramouleshwara Temple, dedicated to Lord Shiva, is a 900-year-old Chalukyan-era temple. Its black granite structure has exquisite carvings and two Shivalingas. The temple reflects both architectural brilliance and spiritual depth. Devotees visit to seek blessings and admire the ancient craftsmanship. It is a protected heritage site under the ASI. Chandramouleshwara Temple is Hubli’s timeless spiritual gem."
  },
  {
    "title": "Indira Gandhi Glass House Garden",
    "description": "This beautiful garden is named after the glasshouse structure that resembles Bengaluru’s Lalbagh. It serves as a venue for exhibitions, cultural programs, and flower shows. Lush lawns, fountains, and walking paths make it a family-friendly destination. The park is especially lively during festivals. Evening strolls here are refreshing. The Glass House Garden is Hubli’s cultural and recreational hub."
  },
  {
    "title": "ISKCON Hubli",
    "description": "ISKCON Hubli is a major spiritual and cultural center dedicated to Lord Krishna. The temple hosts daily bhajans, aartis, and spiritual discourses. Festivals like Janmashtami are celebrated with grandeur, drawing large crowds. The temple also runs social and educational activities. Its architecture is modern yet rooted in tradition. ISKCON Hubli is the city’s devotional landmark."
  },
  {
    "title": "Nrupatunga Betta",
    "description": "Nrupatunga Betta is a small hillock offering panoramic views of Hubli. It is a favorite picnic and trekking spot for locals. The hill has gardens, seating areas, and food stalls. Families often visit in the evenings to enjoy the cool breeze. Its elevated setting makes sunsets and night views magical. Nrupatunga Betta is Hubli’s scenic viewpoint."
  },
  {
    "title": "Banashankari Temple, Amargol",
    "description": "Located between Hubli and Dharwad, Banashankari Temple is a revered shrine dedicated to Goddess Banashankari. Built in Chalukyan style, the temple features intricate stone carvings. Devotees visit year-round, with festivals attracting large gatherings. The temple’s spiritual aura is enhanced by its historic roots. It is an important part of the region’s heritage. Banashankari Temple is Hubli’s divine cultural gem."
  },
  {
    "title": "Navanagar Garden",
    "description": "Navanagar Garden is a popular community park in Hubli. It has children’s play areas, walking paths, and seasonal flower beds. Families use it for evening relaxation and morning walks. Cultural events are sometimes organized here. Its greenery offers a refreshing escape from city life. Navanagar Garden is Hubli’s family-friendly nature spot."
  },
  {
    "title": "Sidharoodha Math",
    "description": "Sidharoodha Math is a spiritual ashram dedicated to Swami Sidharoodha, a saint respected across communities. The math welcomes people of all faiths. Devotees visit for meditation, prayer, and blessings. Annual fairs during his aradhana attract thousands. Its peaceful atmosphere makes it ideal for reflection. Sidharoodha Math is Hubli’s spiritual center of harmony."
  },
  {
    "title": "Agadi Thota",
    "description": "Agadi Thota is an eco-tourism farm located on the outskirts of Hubli. Visitors enjoy traditional North Karnataka food, village activities, and bullock cart rides. It showcases rural life with a cultural touch. Families and groups visit for day-long experiences. The farm is also a model for sustainable tourism. Agadi Thota is Hubli’s countryside cultural retreat."
  },
  {
    "title": "Dharwad (Twin City)",
    "description": "Just 20 km from Hubli, Dharwad complements the city with its cultural and educational heritage. Attractions include the Karnataka University, Dharwad Regional Museum, and numerous temples. Dharwad is also famous for its pedhas (sweets). The twin cities together form a vibrant hub of business, culture, and tourism. Hubli-Dharwad is Karnataka’s emerging metro region. Dharwad is Hubli’s historic twin city."
  }
],


                         "services": [
    {
      "name": "Pune to Hubli Cab",
      "description": "Experience a comfortable and reliable journey from Pune to Hubli with our Pune to Hubli Cab service. Whether traveling for business, leisure, or family visits, our well-maintained fleet ensures a safe and pleasant ride across this long-distance route. Our professional drivers are familiar with the best routes, traffic patterns, and rest stops to make your trip smooth and efficient. With modern vehicles equipped with air conditioning and ample luggage space, we prioritize your comfort and convenience throughout the journey."
    },
    {
      "name": "Book Pune to Hubli Taxi",
      "description": "Booking your taxi from Pune to Hubli is simple and hassle-free with our easy online platform. Choose from a variety of vehicle types, set your pickup location and time, and get instant confirmation. Our dedicated customer support team is available around the clock to assist with your booking and any special requirements. Our Pune to Hubli Taxi service focuses on punctuality, safety, and customer satisfaction, ensuring a seamless travel experience every time you ride with us."
    },
    {
      "name": "Pune to Hubli One Way Cab",
      "description": "Opt for our Pune to Hubli One Way Cab service for a convenient and cost-effective option if you only need one-direction travel. Perfect for business trips, family visits, or relocation purposes, this service provides flexible timing and transparent pricing. Our experienced drivers ensure a timely and secure trip, while our fleet’s variety caters to solo travelers, couples, or groups. Enjoy the convenience of door-to-door service without worrying about return trip arrangements."
    },
    {
      "name": "Pune to Hubli Outstation Cab",
      "description": "Our Pune to Hubli Outstation Cab service is tailored for long-distance travelers who demand reliability, comfort, and safety. Whether you’re heading to Hubli for work, events, or leisure, our vehicles provide spacious interiors, clean environments, and advanced safety features. Skilled drivers with extensive highway experience handle tolls, route optimization, and rest stops to ensure a smooth journey. With 24/7 customer support and easy booking options, your trip from Pune to Hubli becomes a stress-free experience."
    },
    {
      "name": "Cab from Pune to Hubli",
      "description": "Choose our Cab from Pune to Hubli for flexible, private travel tailored to your schedule. We offer a range of vehicles including sedans and SUVs to accommodate your needs, whether traveling solo or with family. Our drivers are courteous professionals who prioritize your safety and comfort, ensuring you reach your destination on time. Transparent fare policies and no hidden charges mean you can travel with peace of mind from Pune to Hubli and back."
    },
    {
      "name": "Pune to Hubli Car Rental",
      "description": "Enjoy the freedom to explore with our Pune to Hubli Car Rental service. Rent a car with or without a driver depending on your preference, and discover the flexibility of traveling at your own pace. Our rental fleet features well-maintained, fuel-efficient cars equipped with modern amenities for maximum comfort. Whether for a short visit or extended stay in Hubli, our rental service is designed to cater to your unique travel needs, supported by straightforward pricing and easy online booking."
    },
    {
      "name": "Pune to Hubli Cab Fare",
      "description": "We offer competitive and transparent Pune to Hubli Cab Fare options tailored to suit various budgets without compromising on quality or comfort. Our fare structure includes all applicable taxes and tolls, with no hidden costs, ensuring you know exactly what you pay. Special discounts and seasonal offers make traveling from Pune to Hubli even more affordable. Book with confidence, knowing you’re getting excellent value for a reliable, safe, and comfortable journey."
    },
    {
      "name": "Hubli to Pune Taxi Booking",
      "description": "For your return trip, our Hubli to Pune Taxi Booking service offers prompt, safe, and comfortable rides back to Pune. Our experienced drivers provide courteous service and ensure timely pickups aligned with your schedule. Whether returning from business, family visits, or holidays, enjoy a seamless travel experience with easy booking options and 24/7 customer support, ensuring peace of mind from start to finish."
    },
    {
      "name": "Affordable Pune to Hubli Cabs",
      "description": "Travel smart with our Affordable Pune to Hubli Cabs, offering budget-friendly rides without sacrificing safety or comfort. Ideal for students, professionals, and families, our economical cabs provide clean, reliable transportation at competitive prices. Regular maintenance and professional drivers guarantee a worry-free journey. Take advantage of our seasonal discounts and promotional offers to enjoy the best fares on your Pune to Hubli trip."
    }
  ],
  "tableData": [
    ["Pune to Hubli Cab", "Book Pune to Hubli Taxi"],
    ["Pune to Hubli One Way Cab", "Pune to Hubli Outstation Cab"],
    ["Cab from Pune to Hubli", "Pune to Hubli Car Rental"],
    ["Pune to Hubli Cab Fare", "Hubli to Pune Taxi Booking"],
    ["Affordable Pune to Hubli Cabs"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Trusted Pune to Hubli Cab Service",
    "WhyChoosedescription": "Platinum24 Cabs provides reliable and comfortable cab services for your journey from Pune to Hubli, ensuring a smooth and hassle-free travel experience."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles to Suit Your Needs",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and tempo travellers tailored to your group size and preferences for Pune to Hubli trips."
  },
  {
    "WhyChooseheading": "Clean and Sanitized Cabs for Safe Travel",
    "WhyChoosedescription": "All vehicles are regularly cleaned and sanitized to ensure a safe and hygienic travel environment."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Pune-Hubli Routes",
    "WhyChoosedescription": "Our professional drivers know the best routes between Pune and Hubli to provide timely and smooth travel."
  },
  {
    "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy transparent fares including tolls, fuel, and driver allowances for a hassle-free Pune to Hubli cab service."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist you with your Pune to Hubli cab bookings."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages Tailored to Your Travel Needs",
    "WhyChoosedescription": "Choose from hourly, daily, or long-term rental plans customized for your Pune to Hubli travel."
  },
  {
    "WhyChooseheading": "Easy Online Booking with Instant Confirmation",
    "WhyChoosedescription": "Book your Pune to Hubli cab quickly and securely through our website or app with immediate confirmation."
  }
]





























    }

    
const faqData = [
    {
        question: 'Does Platinum24 Cabs provide Pune to Hubli cab services?',
        answer: 'Yes, Platinum24 Cabs offers reliable and comfortable cab services from Pune to Hubli with professional drivers and well-maintained vehicles.',
    },
    {
        question: 'How can I book a cab from Pune to Hubli?',
        answer: 'You can book your cab easily through our website, mobile app, or by contacting our 24x7 customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Hubli travel?',
        answer: 'We provide hatchbacks, sedans, SUVs, and luxury cars to suit your travel preferences and group size.',
    },
    {
        question: 'Is one-way cab service available from Pune to Hubli?',
        answer: 'Yes, both one-way and round-trip cab services are available for Pune to Hubli travel.',
    },
    {
        question: 'Are the drivers experienced for Pune to Hubli long-distance trips?',
        answer: 'Absolutely, our drivers are licensed, professional, and familiar with the Pune to Hubli route.',
    },
    {
        question: 'Can I customize pickup and drop-off locations in Pune and Hubli?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points according to your convenience.',
    },
    {
        question: 'What safety and hygiene protocols are followed for Pune to Hubli cabs?',
        answer: 'All vehicles are regularly sanitized, and drivers adhere to strict safety and hygiene measures to ensure passenger safety.',
    },
    {
        question: 'Is Pune to Hubli cab service available 24x7?',
        answer: 'Yes, Platinum24 Cabs operates 24x7 for Pune to Hubli cab bookings.',
    },
    {
        question: 'What payment options are accepted for Pune to Hubli cab bookings?',
        answer: 'We accept cash, digital wallets, UPI, and major credit/debit cards for hassle-free payments.',
    },
    {
        question: 'Are customizable packages available for Pune to Hubli cab service?',
        answer: 'Yes, we offer flexible and customizable packages tailored to your travel itinerary and preferences.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Kiran Shetty',
        feedback: 'The Pune to Hubli cab service was comfortable and reliable. Great experience with Platinum24 Cabs.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Sneha Kulkarni',
        feedback: 'Professional and courteous drivers made my Pune to Hubli trip hassle-free.',
        rating: 5,
    },
];

















































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];








const puneToHubliCabSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Hubli Cab Service",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-hubli-cab.jpg",
  "description": "Book Pune to Hubli cab service with Platinum24 Cabs. Reliable, affordable, and comfortable taxis available for one-way trips, outstation travel, and car rentals. Professional drivers and 24/7 service ensure a smooth journey.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "32150",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-hubli-cab-service"
  }
};





    return (
        <div>

<Helmet>
  <title>Pune to Hubli Cab Service | Affordable Outstation Taxi | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book Pune to Hubli cab service with Platinum24 Cabs. Reliable, affordable, and comfortable taxis available for one-way trips, outstation travel, and car rentals. Professional drivers and 24/7 service ensure a smooth journey."
  />
  <meta
    name="keywords"
    content="Pune to Hubli Cab, Book Pune to Hubli Taxi, Pune to Hubli One Way Cab, Pune to Hubli Outstation Cab, Cab from Pune to Hubli, Pune to Hubli Car Rental, Pune to Hubli Cab Fare, Hubli to Pune Taxi Booking, Affordable Pune to Hubli Cabs"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToHubliCabSchema)}
  </script>
</Helmet>



            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/114.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetohublicabservice;